import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

// WHO returns up to 50 hits; the select stays readable at fewer than that.
const MAX_OPTIONS = 25;

// Below two characters WHO returns noise, and every keystroke would cost a
// round trip. The backend enforces the same floor.
const MIN_QUERY_LENGTH = 2;

/*
Searches ICD-11 through our own gateway rather than calling WHO directly:
the OAuth credentials stay server-side and there is no CORS to negotiate.

Resolves to react-select options carrying the full ICD record, so the caller
can persist the code, title and release alongside the display label.
*/
export const searchICD11 = async (query) => {
  if (!query || query.trim().length < MIN_QUERY_LENGTH) return [];

  try {
    const queryRes = await api({
      method: "GET",
      url: `${API_URL}/icd11`,
      params: { q: query.trim() },
    });

    const { results = [], source } = queryRes.data || {};

    return results.slice(0, MAX_OPTIONS).map((el) => ({
      // Fall back to the local option value when WHO is unreachable and the
      // backend answered from diagnosisoptions instead.
      value: el.code || el.localValue,
      label: el.code ? `${el.code} — ${el.title}` : el.title,
      code: el.code || null,
      title: el.title,
      icdId: el.icdId || null,
      release: el.release || null,
      isFallback: source === "local-fallback",
    }));
  } catch (error) {
    // Returning [] keeps the dropdown usable — react-select shows "no options"
    // rather than the form breaking on a failed lookup.
    return [];
  }
};
